import { EntityActions } from '@datorama/akita';
import { Subject, Observable, merge } from 'rxjs';
import { Entity } from 'projects/app-misc/src/app/modules/data/abstract-entity.store';

export interface EntityModifyEvent {
    action: EntityActions,
    entityId: number
}

export interface EntityAddEvent<T extends Entity> extends EntityModifyEvent {
    entity: T
}

export interface EntityUpdateEvent<T extends Entity> extends EntityModifyEvent {
    entity: T
}

export interface EntityRemoveEvent extends EntityModifyEvent {
}

export class EntityEventEmitter<T extends Entity> {
    private entityAddSubject = new Subject<EntityAddEvent<T>>();
    get add(): Observable<EntityAddEvent<T>> {
        return this.entityAddSubject;
    }

    private entityUpdateSubject = new Subject<EntityUpdateEvent<T>>();
    get update(): Observable<EntityUpdateEvent<T>> {
        return this.entityUpdateSubject;
    }

    private entityRemoveSubject = new Subject<EntityRemoveEvent>();
    get remove(): Observable<EntityRemoveEvent> {
        return this.entityRemoveSubject;
    }

    private any$: Observable<EntityModifyEvent>
    get any(): Observable<EntityModifyEvent> {
        if (!this.any$) {
            this.any$ = merge(
                this.add,
                this.update,
                this.remove
            )
        }

        return this.any$;
    }

    public emitAdd(entity: T): void {
        this.entityAddSubject.next({
            action: EntityActions.Add,
            entityId: entity.id,
            entity
        })
    }

    public emitUpdate(entity: T): void {
        this.entityUpdateSubject.next({
            action: EntityActions.Update,
            entityId: entity.id,
            entity
        })
    }

    public emitRemove(entityId: number): void {
        this.entityRemoveSubject.next({
            action: EntityActions.Remove,
            entityId
        })
    }
}

